import { Container, Col, Row, Button } from "react-bootstrap";
import Rating from "@mui/material/Rating";
import { useState, useMemo } from "react";
import Typography from "@mui/material/Typography";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import BackArrow from "../../components/backArrow";
import { useNavigate, useParams } from "react-router-dom";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import CampaignIcon from "@mui/icons-material/Campaign";
import RedoIcon from "@mui/icons-material/Redo";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ReportIcon from "@mui/icons-material/Report";
import GradeIcon from "@mui/icons-material/Grade";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import "./Forms/form.css";
import Qrmodal from "../../components/QRmodal/Qrmodal";
import { getAsset } from "../../helpers/helper";
import dummyezi from "../../assets/images/dummy/dummyezi.png";
import dummyUser from "../../assets/images/dummy/user-avatar-img.jpg";
import Pagination from "react-bootstrap/Pagination";
import AddIcon from "@mui/icons-material/Add";
import PeopleRatingsModal from "../../components/Rating_People";
import { MainModal } from "@/components";
import ShareModel from "../../components/Sharemodel";
import ShareOption from "../../components/Shareoption";
import { extractIdFromSlug } from "../../utils/slugUtils";
import {
  useGetShopByIdQuery,                    
  useGetShopRatingQuery, 
  useDeleteShopMutation,
  useGetSubscriptionPurchasesByShopQuery,
} from "../../features/shop/shopApiSlice";
import { useGetTransportVehiclesByShopIdQuery } from "../../features/transport/transportVehicleApiSlice";
import { useSelector } from "react-redux";
import ShopStarRankLink from "../../components/ShopStarRank/ShopStarRankLink";

const Transportprofile = () => {
  const { id } = useParams();
  const [smShow, setSmShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showpeoplerating, setShowpeoplerating] = useState(false);
  const handleClosepeople = () => setShowpeoplerating(false);
  const handleShowpeople = () => setShowpeoplerating(true);
const [deleteShop] = useDeleteShopMutation();
  const navigate = useNavigate();
  const [value] = useState(3);
  const [key, setKey] = useState("home");
  const [show, setShow] = useState(0);
  const handleClose = () => setShow(0);
  const onHide = () => setSmShow(false);

  const [showmodal_share, setShowmodal_share] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const handleClosemodal_share = () => setShowmodal_share(false);
  const handleCloseshare = () => setShowshare(false);
  const handleShowshare = () => setShowshare(true);
  
  const itemsPerPage = 50;

  const { data: shopRes } = useGetShopByIdQuery(id, {
    skip: !id,
  });
  const { data: ratingRes } = useGetShopRatingQuery(id, { skip: !id });
  const { data: vehiclesRes } = useGetTransportVehiclesByShopIdQuery(id, {
    skip: !id,
  });

  const shopData = shopRes?.data?.Shop;
  const showrating = ratingRes?.data?.averageRating;
  const { name } = useSelector((state) => state.user);
  const { data: purchaseResponse, isLoading: isPurchaseLoading } = useGetSubscriptionPurchasesByShopQuery(id, { skip: !id });
  const isOwner = name?._id && shopData?.userid && (name._id === shopData.userid || name._id === shopData.userid?._id || name._id.toString() === shopData.userid.toString());

  const carsData = useMemo(() => {
    const dummyData = Array.from({ length: 100 }, (_, index) => ({
      _id: `dummy_${index}`,
      shopid: id,
      brandName: `Vehicle ${index + 1}`,
      description: "Add more vehicle to see here",
      images: [dummyezi],
    }));

    const fetchedData = vehiclesRes?.data?.TransportVehicles || [];
    if (fetchedData.length > 0) {
      const combinedData = [...fetchedData, ...dummyData];
      combinedData.sort((a, b) => (a._id.startsWith("dummy_") ? 1 : -1));
      return combinedData.slice(0, 100);
    }
 
    return dummyData;
  }, [vehiclesRes, id]);

  const shopImageSrc = shopData?.image ? getAsset(shopData.image) : dummyUser;

  const handeldelete = async () => {
    try {
      const res = await deleteShop(id).unwrap();
      if (res?.success) {
        setShow(0);
        SuccessNotify("Profile Deleted");
        navigate("/create-transport");
      }
    } catch {
      FailedNotify("Failed to delete");
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = carsData
    ? carsData.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = carsData ? Math.ceil(carsData.length / itemsPerPage) : 0;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const renderPagination = () => {
    const items = [];
    const maxPagesToShow = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    items.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    items.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return (
      <Pagination className="justify-content-center mt-3">{items}</Pagination>
    );
  };

  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal_share}
        handleClosemodal={handleClosemodal_share}
        handleShowshare={handleShowshare}
        shareurl={`/buying-transport/${id}`}
        shopTitle={shopData?.shopname}
        shopDesc={shopData?.description}
        shopImage={shopData?.image?.[0]}
      />
      <PeopleRatingsModal
        show={showpeoplerating}
        handleClosepeople={handleClosepeople}
      />
      <Qrmodal show={smShow} handleClosemodal={onHide} />
      {show === 1 && (
        <MainModal
          variant="deleteModal"
          show={show}
          title="Profile"
          handleClose={handleClose}
          handledelete={handeldelete}
          id={id}
        />
      )}
      <Container>
        <Col
          lg="12"
          xl="11"
          className="border_2 b-radius mx-auto screenHeight ps-5 pe-5"
          style={{ backgroundColor: "#F2F2F2" }}
        >
          <Row className="mb-3">
            <Col>
              <Button variant="link" className="go-back">
                <BackArrow />
              </Button>
            </Col>
            <Col className="text-end">
              <button
                className="text-white bg-blue  rounded mt-2 pt-1 pb-1 ps-4 pe-4"
                style={{
                  backgroundColor: "#0353a4",
                  border: "none",
                  fontSize: "11px",
                }}
                onClick={() => setShowmodal_share(true)}
              >
                Share <RedoIcon className="share_icon_f" />
              </button>
            </Col>
          </Row>

          {/* Profile Header */}
          <Row className="profile-header align-items-start bg-white p-4 rounded">
            <Col xs={12} md={2} className="text-center">
              <img
                src={shopImageSrc}
                alt={shopData?.shopname || "Transport profile"}
                className="profile-photo rounded-circle mb-3"
                crossOrigin="anonymous"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = dummyUser;
                }}
              />
            </Col>
            <Col xs={12} md={10}>
              <Row className="mt-2">
                <Col md={8}>
                  <h4 className="mb-0">{shopData?.shopname}</h4>
                  <ShopStarRankLink
                    shop={shopData}
                    shopId={id}
                    compact
                    businessType="transportShop"
                  />
                  <p className="text-muted mb-0">
                    {" "}
                    <b>Profile ID:</b> {shopData?.shopid ? btoa(shopData.shopid) : ""}
                  </p>
                  <p className="text-muted mb-0">{shopData?.shopaddress}</p>
                  {/* <div className="d-flex flex-wrap m-1 ms-0">
               <Badge pill className="me-2 mb-2 badge-silver">Logo Design</Badge>
<Badge pill className="me-2 mb-2 badge-silver">UI/UX</Badge>
<Badge pill className="me-2 mb-2 badge-silver">Posters Designs</Badge>
<Badge pill className="me-2 mb-2 badge-silver">Branding</Badge>

              </div> */}
                  <div className="d-flex align-items-center mb-2">
                    {showrating && showrating?.length > 0 ? (
                      <>
                        <p className="marginset d-flex mb-1">
                          <GradeIcon
                            fontSize="small"
                            style={{ marginTop: "1px" }}
                          />
                          <b>{showrating}</b>
                        </p> &nbsp;&nbsp;
                        <button
                          className="text-white rounded pt-0 pb-0 ps-3 pe-3 border-0 font_11"
                          style={{ backgroundColor: "#0353a4" }}
                          onClick={handleShowpeople}
                        >
                          View Rating
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col
                  md={4}
                  className="text-end d-flex flex-column justify-content-start"
                >
                  <Button
                    variant="primary"
                    className="mb-2"
                    onClick={() => navigate(`/update-transport/${id}`)}
                  >
                    Update Profile
                  </Button> 
                  <Button
                    variant="primary"
                    className="mb-2"
                    onClick={() => navigate("/homemade-items-shops")}
                  >
                    Business Dashboard
                  </Button>
                  <Button variant="primary" className="mb-2" onClick={()=>navigate(`/add-consultancy-services-profile/${id}`)}>Add Consultancy Services</Button>
                  {isOwner && (
                    <>
                      {isPurchaseLoading && (
                        <div className="d-flex justify-content-center my-1 mb-2">
                          <span className="spinner-border spinner-border-sm text-primary" role="status" />
                        </div>
                      )}
                      {!isPurchaseLoading && (
                        <Button
                          variant="primary"
                          onClick={() => {
                            const bt =
                              shopData?.businessType || "transportShop";
                            const sid = shopData?._id || id;
                            if (bt) localStorage.setItem("BTtogetMarketer", bt);
                            if (sid) localStorage.setItem("shopid", String(sid));
                            navigate("/hire-marketers");
                          }}
                        >
                          Hire Us For Your Marketing & Ads
                        </Button>
                      )}
                    </>  
                  )}
                </Col>
              </Row>
            </Col>  
          </Row>

          {/* Tabs */}
          <Row className="tabs-row bg-white p-3 rounded mt-3 justify-content-start">
            <Col xs="auto" className="me-4">
              <span
                role="button"
                onClick={() =>
                  navigate(`/transport-suggestion/${shopData?.shopid}`)
                }
              >
                <EmojiObjectsIcon /> Suggestions
              </span>
            </Col>
            <Col xs="auto" className="me-4">
              <span
                role="button"
                onClick={() => navigate(`/Transport-Report-section/${id}`)}
              >
                <ReportIcon /> Reports
              </span>
            </Col>
            <Col xs="auto" className="me-4">
              <span
                role="button"
                onClick={() => navigate("/promote-transport")}
              >
                <CampaignIcon /> Promote Your Shop
              </span>
            </Col>
            <Col xs="auto">
              <span role="button">
                <LocationOnIcon /> Share location
              </span>
            </Col>
          </Row>

          <Row className="rounded bg-white mt-3">
            <Col className="" lg="12 mt-2">
              <div className="d-flex justify-content-end mt-3 position-relative">
                <p
                  className="addmore_buttnn "
                  onClick={() => navigate(`/transport-addmore-form/${id}`)}
                >
                  <AddIcon fontSize="small" />| Add More
                </p>
              </div>

              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3 ms-1 display-setting font_small"
              >
                <Tab eventKey="home" title="Transport">
                  <Row className="t-scroll noscroll">
                    <Row className="pe-0">
                      {currentItems?.map((cars) => {
                        const isDummyVehicle = cars._id.startsWith("dummy_");
                        const imageSrc = cars?.images[0]
                          ? isDummyVehicle
                            ? cars.images[0]
                            : getAsset(cars.images[0])
                          : dummyezi;

                        return (
                          <>
                            <Col lg="4" className="mt-2 imageheightset ">
                              <div className="img_container border_3 rounded">
                                <img
                                  key={cars._id}
                                  src={imageSrc}
                                  alt={cars.brandName || "Dummy Image"}
                                  style={{
                                    maxHeight: "180px",
                                    objectFit: "cover",
                                  }}
                                  className="food_img"
                                  crossOrigin="anonymous"
                                  onError={(e) =>
                                    console.error(
                                      "Image failed to load:",
                                      cars?.images[0],
                                      e
                                    )
                                  }
                                />
                              </div>
                            </Col>
                            <Col lg="8" className="border_2 b-radius mt-2 p-3">
                              <Row className="mt-2">
                                <Col lg="5">
                                  <h4 className="font-bold">
                                    {cars?.brandName}
                                  </h4>
                                </Col>
                                <Col lg="3"></Col>
                                <Col
                                  lg="4"
                                  className="d-flex align-items-end mb-3"
                                >
                                  <Typography component="legend">
                                    Rating
                                  </Typography>
                                  <Rating
                                    name="read-only"
                                    value={value}
                                    readOnly
                                  />
                                  <p className="mb-1 font_small"></p>
                                </Col>
                              </Row>
                              <Row className="mt-1">
                                <Col lg="8">
                                  <p className="mb-0">
                                    <b>Description</b>
                                  </p>
                                  <p className="font-grey">
                                    {cars?.description?.length > 160
                                      ? `${cars?.description?.substring(
                                          0,
                                          160
                                        )}...read more`
                                      : cars?.description}
                                  </p>
                                </Col>

                                <Col lg="12">
                                  <button
                                    className="viewshopnew"
                                    onClick={() =>
                                      isDummyVehicle
                                        ? navigate(`/transport-addmore-form/${id}`)
                                        : navigate(
                                            `/vehicaldetail/${cars?._id}/${cars?.shopid}`
                                          )
                                    }
                                  >
                                    {isDummyVehicle ? "Add Vehicle" : "View"}
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                          </>
                        );
                      })}
                    </Row>
                  </Row>
                  {totalPages > 1 && renderPagination()}
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Col>
      </Container>
    </>
  );
};

export default Transportprofile;
